function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

export var createAction = function createAction(name, action) {
  if (action === void 0) {
    action = function action() {
      return {};
    };
  }

  var actionCreator = function actionCreator() {
    return _extends({
      type: name
    }, action.apply(void 0, arguments));
  };

  actionCreator.toString = function () {
    return name;
  };

  return actionCreator;
};